/**
 * Поле «Зміна» задачі: зміна водія задачі, в межах якої вона виконується.
 * У формі пропонуються лише незавершені зміни обраного водія; бекенд перевіряє,
 * що зміна належить водію задачі. В обмін з ERP поле не входить.
 */
import { formatAppDate } from '@/Ship/Helpers/appTime'

import type { ShiftStatus } from '@/Containers/ShiftSection/ShiftContainer/Contracts/ShiftStatus'

/** Статуси змін, які можна обрати в задачі: завершена зміна нових задач не приймає */
export const SELECTABLE_SHIFT_STATUSES: ShiftStatus[] = ['new', 'started']

/** Підпис зміни: «SH-261002-ABCDE · 02.10.2026»; без даних — null */
export const shiftLabel = (shift: any): string | null => {
    if (!shift || typeof shift !== 'object' || !shift.code) return null
    const date = shift.shiftDate ? formatAppDate(shift.shiftDate, 'DD.MM.YYYY') : ''
    return date ? `${shift.code} · ${date}` : shift.code
}

/**
 * Фільтр опцій зміни: незавершені зміни водія; без водія — порожній (поле заблоковане).
 * Статуси — явним `in`: масив SelectInput розгорнув би в кілька умов `=` через AND.
 */
export const shiftFilterFor = (driverUuid: string | null): Record<string, any> =>
    driverUuid ? { 'driver.uuid': driverUuid, status: { op: 'in', value: SELECTABLE_SHIFT_STATUSES } } : {}
